import React from 'react';
import { IncidentHistory } from '../../components/incidents/IncidentHistory';

export const IncidentHistoryPage = ({ user }: { user: any }) => (
  <div className="p-4 md:p-6">
    <div className="mb-5">
      <h1 className="text-2xl font-bold text-white mb-1">Historique des incidents</h1>
      <p className="text-gray-400 text-sm">Journal complet · Recherche · Export CSV</p>
    </div>
    <IncidentHistory user={user} />
  </div>
);
